import React from "react";
import classnames from "classnames";

import { CommonProps, getClasses } from "./buttonCommon";
import { replaceClasses } from "../utils/replaceClasses";

export const HrefLink = (
  props: CommonProps & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
) => {
  const { size, kind, iconLeft, iconRight, children, disabled, classNameOverride, ...p } = props;
  if (kind === "link") {
    const cls = classnames("inline text-blue underline hover:text-info", {
      "cursor-not-allowed": disabled,
      "text-button-disabled-text": disabled,
      "hover:text-button-disabled-text": disabled,
    });
    return (
      <a className={cls} {...p} href={disabled ? undefined : p.href}>
        {children}
      </a>
    );
  }
  const c = getClasses(size, kind, disabled);
  return (
    <a
      className={replaceClasses(classnames(c.sizeClass, c.kindClass), classNameOverride)}
      {...p}
      href={disabled ? undefined : p.href}
    >
      {iconLeft ? iconLeft({ className: c.iconClass }) : null}
      <span className="align-middle">{children}</span>
      {iconRight ? iconRight({ className: c.iconClass }) : null}
    </a>
  );
};
